import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/ui/sheet";
import { Button } from "@/ui/button";
import AddRFProfileSetupTSX from "./AddRFProfileSetupTSX";

type ActionMeta = {
  title?: string;
  profile: any;
  checkedDataItem?: any;
  edit?: boolean;
};

type Actions = {
  action: string;
  actionMeta?: ActionMeta | null;
  bulkAction?: string | null;
};

type Props = {
  show: boolean;
  handleSlide: () => void;
  actions: Actions;
  setSelectedState: (v: any) => void;
  dataTableName: string;
  updateData?: () => void;
};

const RFProfileSetupSheet: React.FC<Props> = ({
  show,
  handleSlide,
  actions,
  setSelectedState,
  dataTableName,
  updateData,
}) => {
  const isEdit = !!actions?.actionMeta?.edit;
  const computedTitle = isEdit ? "Edit Profile Setup" : "Add Profile Setup";
  const saveRef = React.useRef<(() => void) | null>(null);

  return (
    <Sheet
      open={show}
      onOpenChange={(open: boolean) => {
        if (!open) handleSlide();
      }}
    >
      <SheetContent side="right" className="w-full sm:w-[900px] px-4 sm:px-6">
        <div className="flex h-full flex-col">
          <SheetHeader className="shrink-0 px-4 sm:px-6">
            <SheetTitle className="text-base sm:text-lg text-foreground dark:text-white">
              {computedTitle}
            </SheetTitle>
          </SheetHeader>

          <div className="flex-1 overflow-auto px-4 sm:px-6 pb-24">
            <div className="mt-3">
              <AddRFProfileSetupTSX
                handleSlide={handleSlide}
                title={computedTitle}
                actionMeta={actions?.actionMeta as any}
                updateData={updateData as any}
                setSelectedState={setSelectedState as any}
                dataTableName={dataTableName as any}
                onSaveRef={saveRef}
                hideInlineFooter
              />
            </div>
          </div>

          <div className="shrink-0 border-t border-border bg-popover px-4 sm:px-6 py-3">
            <div className="flex justify-end gap-2">
              <Button
                type="button"
                variant="outline"
                onClick={() => handleSlide()}
              >
                Cancel
              </Button>
              <Button type="button" onClick={() => saveRef.current?.()}>
                Save
              </Button>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default RFProfileSetupSheet;
